import { Flex, Tag, Text, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import FilterItem from "../../../@types/interfaces/app/filter-item.interface";

const CategoryItem: React.FC<FilterItem> = ({
  propertyName,
  chartName,
  filterCategory,
}) => {
  const categoryFilterBreadcrumbTextColor = useColorModeValue(
    "light.categoryFilterBreadcrumbTextColor",
    "dark.categoryFilterBreadcrumbTextColor"
  );

  const categoryFilterBreadcrumbBgColor = useColorModeValue(
    "light.categoryFilterBreadcrumbBgColor",
    "dark.categoryFilterBreadcrumbBgColor"
  );

  return (
    <Flex
      cursor="pointer"
      w="full"
      align="center"
      px="12px"
      py="4px"
      _hover={{
        bgColor: categoryFilterBreadcrumbBgColor,
      }}
    >
      <Flex flex="1" flexDir="column">
        <Text
          color={categoryFilterBreadcrumbTextColor}
          fontSize="10px"
          maxW="130px"
        >
          {chartName}
        </Text>
        <Text mt="3px" fontSize="13px">
          {propertyName}
        </Text>
      </Flex>
      <Tag
        p="8px"
        borderRadius="200px"
        fontWeight="medium"
        bgColor="rgba(139, 85, 252, 0.2)"
        color="#BA9AFC"
        fontSize="10px"
      >
        {filterCategory}
      </Tag>
    </Flex>
  );
};

export default CategoryItem;
